export default {"src":"/_next/static/media/rail.854d08e5.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};